// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vs0udcUTHpxL1rDucqf3{margin-bottom:6px}`, "",{"version":3,"sources":["webpack://./src/pages/broadcasts/ui/BroadcastView/ui/BroadastName/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA","sourcesContent":[".broadcastName {\n  margin-bottom: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"broadcastName": `Vs0udcUTHpxL1rDucqf3`
};
export default ___CSS_LOADER_EXPORT___;
